import load_media from "load_media"
import daltonize_images from "daltonize_images"
import screen from "screen"
import $ from "cash-dom"

const init_image_with_caption = (img_container) => {
  const $img_container = $(img_container)
  load_media($img_container)
  daltonize_images($img_container.find("img"))
  add_expander_to_images_with_captions($img_container)
}

const add_expander_to_images_with_captions = ($img_container) => {
  if (screen.is_sm_screen()) return
  // only make it expandable if it is aligned inline left or right
  if (
    !$img_container.hasClass("outset-left") &&
    !$img_container.hasClass("outset-right")
  ) {
    return
  }
  return make_expandable($img_container.find("img"), $img_container)
}

const fa_icon = (name) => `
  <svg class="fa ${name}">
    <use href="${window.gon.icons_path}#${name}"></use>
  </svg>
`

export const make_expandable = (img, img_container) => {
  const _add_expander = (dom) => {
    const $dom = $(dom)
    $dom.addClass("image-extendable")
    $dom.prepend(fa_icon("fa-expand"))
    return $dom.on("click", () => {
      if ($dom.hasClass("image-extendable--active")) {
        $dom.find(".fa-compress").remove()
        $dom.prepend(fa_icon("fa-expand"))
      } else {
        $dom.find(".fa-expand").remove()
        $dom.prepend(fa_icon("fa-compress"))
      }
      $dom.toggleClass("image-extendable--active")
    })
  }

  // find natural width http://stackoverflow.com/a/21364002/971260
  const image = new Image()
  image.src = $(img).attr("src")
  image.onload = function() {
    if (this.naturalWidth < 500) return
    return _add_expander(img_container)
  }
}

export default init_image_with_caption
